import * as React from 'react';
import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import commons from '../../../assets/styles/commons';
import colors from '../../../assets/styles/colors';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Control, Controller } from 'react-hook-form';
import FormHelperText from '@material-ui/core/FormHelperText';

interface CustomizedInputsProps {
  label: string;
  defaultValue?: any;
  id?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  size?: 'small' | 'medium';
  name: string;
  control: Control<any>;
  value?: any;
  startAdornment?: any;
  endAdornment?: any;
  mask?: (value: any) => string;
}

const CustomInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
    color: colors.neutral.gray,
  },

  '&.MuiInputBase-root ': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: colors.secondary.softBlue,
    border: '1px solid',
    borderColor: colors.primary.orange,
    flex: 1,
    width: 'auto',
    height: '18px',
    padding: '5px 12px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    fontFamily: commons.fontFamily,

    '&:focus': {
      boxShadow: `rgba(255, 114, 6, 0.25) 0 0 0 0.2rem`,
      borderColor: colors.primary.orange,
    },
    '&.Mui-focused': {
      color: colors.primary.orange,
    },
  },

  '& .MuiTypography-root': {
    fontFamily: commons.fontFamily,
    color: colors.primary.orange,
    fontSize: 18,
  },

  '& .MuiInputAdornment-positionStart': {
    marginRight: 0,
  },
}));

const InputDisabledOrange: React.FC<CustomizedInputsProps> = ({
  label,
  defaultValue,
  value,
  id,
  style,
  onChange,
  size = 'small',
  startAdornment,
  endAdornment,
  name,
  control,
  mask,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <Box
      component="div"
      sx={{
        display: 'grid',
      }}
    >
      <Controller
        name={name}
        control={control}
        render={({ field: { value }, fieldState: { error } }) => (
          <FormControl size={size}>
            <InputLabel
              variant="standard"
              shrink
              htmlFor={id}
              sx={{
                fontFamily: commons.fontFamily,
                color: colors.primary.orange,
                fontSize: 18,
                '&.Mui-focused': {
                  color: colors.primary.orange,
                },
                ...style,
              }}
            >
              {label}
            </InputLabel>
            <>
              <CustomInput
                defaultValue={defaultValue}
                value={mask ? mask(value) : value.toFixed(2)}
                onChange={handleChange}
                id={id}
                disabled={true}
                endAdornment={
                  <InputAdornment position="end">{endAdornment}</InputAdornment>
                }
                startAdornment={
                  <InputAdornment position="start">
                    {startAdornment}
                  </InputAdornment>
                }
              />
              {error && (
                <FormHelperText style={{ color: colors.error.intenseRed }}>
                  {error.message}
                </FormHelperText>
              )}
            </>
          </FormControl>
        )}
      />
    </Box>
  );
};

export default InputDisabledOrange;
